<!-- TODO WIP html structure -->
<!-- Pagination	-->
<div class="row mx-0">
	<div
		*ngIf="renderPagination"
		class="operationWrapper col-auto px-0 ml-auto"
	>
		<app-pagination
			#paginationCmp
			*ngIf="pagingData"
			[defaultPagingData]="pagingData"
			[pagingInput]="paging"
			(operationChangedEmitter)="onOperationPaginationEmitter($event, true)"
			(operationInitializedEmitter)="onOperationPaginationEmitter($event)"
		></app-pagination>
	</div>
</div>
